<template>
  <div class="bto-sb-event-odds-content" ref="oddsContainer">
    <Fragment v-if="matches.length">
      <MatchLabels :t="t"></MatchLabels>
      <div class="bto-sb-event-odds" v-for="(match, index) in matches" :key="match.betRadarId">
        <!-- Show tournaments title and category if isOverviewProp is true -->
        <div class="bto-sb-event-odds-title" v-show="showOverviewTitle(match, index)">
          <h4>{{ match.tournamentName }}, {{ match.categoryName }}</h4>
        </div>
        <MatchDetails
          :match="match"
          :showTeamIcon="showTeamIcon"
          :show-odd-popup="showOddPopup"
          :hide-odd-popup="hideOddPopup"
          :get-popup-title="getPopupTitle"
          :expanded-view="expandedView"
          :has-live-stream="hasLiveStream"
          :openLiveMatch="openLiveMatch"
        >
        </MatchDetails>
        <div class="bto-sb-event-odds-right">
          <MatchInfo :match="match" :showStatistics="showStatistics" :showFavorite="showFavorite" />
          <div
            class="bto-sb-event-odds-cell"
            v-for="(market, mid, i) in markets"
            :class="{
              'bto-sb-md-none': i === 1,
              'bto-sb-lg-none': i === 2
            }"
            :key="`mid${mid}`"
          >
            <!-- Show market labels only on first row -->
            <MarketLabels v-if="index === 0" :t="t" :is-three-way="isSportTreeWay" :market="market">
            </MarketLabels>
            <Fragment v-if="match.odds.hasOwnProperty(mid)">
              <!-- Show SBV column if market outcomes has sbv values -->
              <span class="bto-sb-event-odd bto-sb-odd-special" v-if="market.sbv">{{
                match.odds[mid].specialBetValue
              }}</span>
              <!-- Display market outcomes -->
              <MatchOdd
                v-for="(outcome, oi) in match.odds[mid].outcomes"
                :key="`oi${oi}`"
                :is-three-way="isSportTreeWay"
                :match="match"
                :odd="match.odds[mid]"
                :outcome="outcome"
                :formatOutcome="formatOutcome"
                :marketInf="market"
                :t="t"
                :is-odd-selected="isOddSelected"
                :expanded-view="expandedView"
              />
            </Fragment>
            <Fragment v-else>
              <!-- Display empty odds -->
              <span class="bto-sb-event-odd bto-sb-odd-special" v-show="market.sbv">--</span>
              <span class="bto-sb-event-odd" v-for="m in market.on.length" :key="`m${m}`">--</span>
            </Fragment>
          </div>
          <!--                    <Fragment v-if="Object.keys(markets).length < 3">-->
          <!--                        &lt;!&ndash; Display empty cells if market count is less than 3 &ndash;&gt;-->
          <!--                        <div class="bto-sb-event-odds-cell" v-for="cell in (3 - Object.keys(markets).length)"-->
          <!--                             :class="{-->
          <!--                            'bto-sb-md-none':cell + Object.keys(markets).length === 2,-->
          <!--                            'bto-sb-lg-none':cell + Object.keys(markets).length === 3,-->
          <!--                          }"-->
          <!--                             :key="`cell${cell}`"></div>-->
          <!--                    </Fragment>-->
          <MoreOdds
            :match="match"
            :cashOutVisibility="cashOutVisibility"
            :showMarketsInMatch="showMarketsInMatch"
          ></MoreOdds>
        </div>
      </div>
    </Fragment>
  </div>
</template>

<script>
  import Vue from 'vue';
  import store from '../../../../store';
  import { EventBus } from "../../../../services/event-bus-service";
  import { LiveProps } from '../util/liveProps';
  import MatchDetails from '../components/match-details';
  import MatchInfo from '../components/match-info';
  import MoreOdds from '../components/more-odds';
  import FavoriteComponent from '../../../shared/favorite-component';
  import StatisticsComponent from '../../../common/statistics-component';
  import MatchLabels from "../components/match-labels";
  import MarketLabels from "../components/market-labels";
  import MatchOdd from '../components/match-odd';
  import { isOddActive } from '@bto-services/betslip-core';
  import { urlFriendlyParam, formatOddDisplay } from '@bto-services/utils';

  Vue.component('favorite-component', FavoriteComponent);
  Vue.component('statistics-component', StatisticsComponent);


  export default {
    name: 'LiveDefault',
    props: {
      ...LiveProps,
      expandedView: {
        type: Boolean,
        default: false
      },
      isSportTreeWay: {
        type: Boolean,
        required: true
      },
      matches: {
        type: [Array, Object],
        required: true
      },
      markets: {
        type: Object,
        required: true
      },
      showNoMatchesMsg: {
        type: Boolean,
        default: false
      },
    },
    created() {
      EventBus.$on('clearSelectedOutcome', this.deselectOdd);
      EventBus.$on('clearMessages', this.deselectAllOdds);
      EventBus.$on('highlightBetItem', this.selectOdd);
    },
    destroyed() {
      EventBus.$off('clearSelectedOutcome', this.deselectOdd);
      EventBus.$off('clearMessages', this.deselectAllOdds);
      EventBus.$off('highlightBetItem', this.selectOdd);
    },
    computed: {
      cashoutEnabledDB() {
        return store.getters.getCashoutDbSetting;
      },
      /**
       * cash out visibility on match level
       */
      cashoutEnabledUser() {
        return store.state.playerInfoModule.playerInfo.cashout;
      },
      cashOutVisibility() {
        return this.cashoutEnabledDB &&
          (!APP_SETTINGS.player.token || this.cashoutEnabledUser);
      },
      /**
       * Get first market id
       */
      getFirstMid() {
        const marketIds = Object.keys(this.markets);
        return typeof marketIds[0] !== 'undefined' ? marketIds[0] : null;
      },
      /**
       * Get formated outcome
       */
      formatOutcome() {
        return (decimalOutcome) => {
          return formatOddDisplay(decimalOutcome, this.$root.oddFormat);
        };
      },
      /**
       * Show / Hide overview title
       */
      showOverviewTitle() {
        return (match, index) => {
          if (!this.isOverviewProp) {
            return false;
          }
          if (index === 0) {
            return true;
          }
          const prevMatch = this.matches[index - 1];
          return match.tournamentId !== prevMatch.tournamentId;
        };
      }
    },
    methods: {
      /**
       * Get popup title
       */
      getPopupTitle(match) {
        return `${match.homeTeam} ${match.score.home} : ${match.score.away} ${match.guestTeam}`;
      },
      /**
       * Return a seoGame like structure for a live match url
       */
      openLiveMatch(match) {
        const categoryName = urlFriendlyParam(match.tournamentName);
        const eventName = urlFriendlyParam(`${match.homeTeam} vs ${match.guestTeam}`);
        const sportName = urlFriendlyParam(match.sportName);
        return { name: 'seoGameLive', params: { sportName, categoryName, eventName, matchId: match.betRadarId } };
      },
      /**
       * Show odd popup
       */
      showOddPopup(event, msg) {
        EventBus.$emit('showoddmarketpopup', {
          message: msg,
          e: event
        });
      },
      /**
       * Hide odd popup
       */
      hideOddPopup() {
        EventBus.$emit('hideoddmarketpopup');
      },
      /**
       * Check if the match is availlable for live streaming
       */
      hasLiveStream(matchId) {
        return !!store.getters.getInternalLiveStreamingMatch(matchId).streamId;
      },
      /**
       * Checks if odd is selected
       * @param props
       * @returns {boolean|boolean}
       */
      isOddSelected(props) {
        return isOddActive({
          matchId: props.match.matchId,
          outcomeId: props.outcome.id,
          marketId: props.odd.marketId,
        });
      },
      /**
       * Remove active class from single outcome
       * @param {string} oClass - Unique id (mod-${matchId}-${outcomeId}) to find outcome
       */
      deselectOdd(oClass) {
        this.toggleOdd(oClass, false);
      },
      /**
       * Add active class to single outcome
       * @param {string} oClass - Unique id (mod-${matchId}-${outcomeId}) to find outcome
       */
      selectOdd(oClass) {
        this.toggleOdd(oClass, true);
      },
      /**
       * Toggle active outcome class for single outcome
       * @param {string} oClass - Unique id (mod-${matchId}-${outcomeId}) to find outcome
       * @param {boolean} [isSelected] - Flag weather to add or remove active class
       */
      toggleOdd(oClass, isSelected = false) {
        if (!this.$refs.oddsContainer) {
          return;
        }
        const activeOutcome = this.$refs.oddsContainer.querySelector(`#${oClass}`);
        if (activeOutcome) {
          if (isSelected) {
            activeOutcome.classList.add('bto-sb-event-odd-active');
          } else {
            activeOutcome.classList.remove('bto-sb-event-odd-active');
          }
        }
      },
      /**
       * Remove active class from all active outcomes
       */
      deselectAllOdds() {
        if (!this.$refs.oddsContainer) {
          return;
        }
        const allOdds = this.$refs.oddsContainer.querySelectorAll('span.bto-sb-event-odd-active');
        if (allOdds) {
          for (let i = 0; i < allOdds.length; i += 1) {
            allOdds[i].classList.remove('bto-sb-event-odd-active');
          }
        }
      },
    },
    components: {
      MatchDetails,
      MatchInfo,
      MoreOdds,
      MatchLabels,
      MarketLabels,
      MatchOdd,
    }
  };
</script>
